import ApiClient from "@/libs/http-client";

const DashboardService = {
  endpoints(route, param) {
    const url = {
      getTodos: `api/todos?type=${param}`,
      createTodo: 'api/todos',
      deleteTodo: `api/todos/${param}`,
      changeStatus: `api/todos/${param}`,
      getAllCandidates: `/api/candidates?page=${param.page}&per_page=${param.perPage}&id=${param.authorId}`,
      getTags: `/api/candidates/tags?type=${param.type}`,
      getCandidatesInOnePage: `/api/candidates?per_page=${param.amount}&id=${param.authorId}`,
      getCandidatesStat: `/api/candidates/stat?id=${param.authorId}`,
      getCandidatesInOnePageDetails: `/api/candidates?per_page=${param.amount}&id=${param.authorId}&position_id=${param.position}&status_id=${param.status}&hr_id=${param.hr}&player_type=${param.playerType}&stack_id=${param.stack}&last_start=${param.from}&last_end=${param.to}&search=${param.search}`,
      getOneCandidate: `/api/candidates/${param.id}`,
      createCandidate: '/api/candidates',
      createTag: '/api/candidates/tags',
      deleteCandidate: `/api/candidates/${param.id}`,
      deleteTag: `/api/candidates/tags/${param}`,
      editCandidate: `/api/candidates/${param.id}`,
    };

    return url[route];
  },

  get(url, param = {}) {
    return ApiClient.get(this.endpoints(url, param));
  },
  put(url, params = {}, data, config = {}) {
    return ApiClient.put(this.endpoints(url, params), data, config);
  },
  post(url, params = {}, data, config = {}) {
    return ApiClient.post(this.endpoints(url, params), data, config);
  },
  patch(url, params = {}, data, config = {}) {
    return ApiClient.patch(this.endpoints(url, params), data, config);
  },
  delete(url, params = {}, config = {}) {
    return ApiClient.delete(this.endpoints(url, params), config);
  },
  editTask(data, config) {
    return ApiClient.put(`/api/todos/${data.id}`, data.payload, config)
  },
};

export default DashboardService;
